import Layout, { unstable_settings } from "@components/Account/Layout";
import { ProfileRouteLoadingFallback } from "@components/Account/You/ProfileLoadingState";

export { unstable_settings };
export const SuspenseFallback = ProfileRouteLoadingFallback;
export default Layout;
